import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import map from 'lodash/map';
import { Trans } from 'react-i18next';

const Container = styled.div`
	bottom: 4vh;
	color: ${(props) => props.theme.colors.white};
	font: ${(props) => props.theme.font.default};
	font-size: 3vmin;
	position: absolute;
	right: 6vw;
`;

const Title = styled.span``;

const List = styled.ul`
	font-weight: bold;
	list-style-type: none;
	margin-block-end: 0;
	margin-block-start: 0;
	padding-inline-start: 0;
`;

const Item = styled.li`
	&::before {
		color: ${(props) => props.theme.colors.veryLightBlue};
		content: '• ';
		font-weight: normal;
	}
`;

export interface Props {
	needs: string[];
}

const MobilityNeedsOverlay: FunctionComponent<Props> = (props: Props) => {
	const { needs } = props;
	const needsComponents = map(needs, (need, index) => (
		<Item key={index}>{need}</Item>
	));

	return (
		<Container>
			<Title>
				<Trans>mobility_needs.title</Trans>
			</Title>
			<List>{needsComponents}</List>
		</Container>
	);
};

export default MobilityNeedsOverlay;
